<template>

    <!-- <ConfirmationDialog ref="deleteConfirmation" title="Delete Platform" message="Are you sure you want to delete this platform?" :verificationString="pendingDeletePlatform.name"  @confirm="deletePlatform()" /> -->

    <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
            <span class="text-h5">Users</span>
            <v-btn color="primary" @click="$emit('create')">
                <v-icon start>mdi-plus</v-icon>
                Create User
            </v-btn>
        </v-card-title>

        <!-- <v-container v-if="pendingUsers.length > 0" class="flex-d">
            <v-card-subtitle class="text-h6">
                Pending Users
            </v-card-subtitle>

            <v-row>
                <v-col cols="6">

                    <v-table
                    hide-default-header
                    hide-default-footer>
                        <thead >
                            <tr>
                                <th>Username</th>
                                <th>Email</th>
                                <th>Approve</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in pendingUsers" v-bind:key="user.username">
                                <td class="text-left"> {{ user.username }}</td>
                                <td class="text-left"> {{ user.email }}</td>
                                <td class="text-left"> <v-btn color="primary" @click="updateUserRole(user, 'reporter')">Approve</v-btn></td>
                            </tr>
                        </tbody>
                    </v-table>
                </v-col>

            </v-row>

        </v-container> -->

            <v-card-subtitle class="text-h6">
                Active Users
            </v-card-subtitle>
          
            <VDataTable
                v-model:expanded="expanded"
                :headers="headers"
                :items="activeUsers"
                :items-per-page="25"
                :editabled="true"
                item-value="email"
                hide-default-footer

                align="left"
                row-class="hightlight-row"
                >

                <template v-slot:item.name="{ item }">
                    {{ item.raw ? getUserDisplayName(item.raw) : '-' }}
                </template>



                <template v-slot:item.actions="{ item }">
                    <v-btn
                        icon="mdi-pencil"
                        size="small"
                        variant="text"
                        @click="handleEdit(item)"
                        title="Edit User"
                    ></v-btn>
                    <v-btn
                        icon="mdi-delete"
                        size="small"
                        variant="text"
                        color="error"
                        @click.stop="verifyDelete(item.raw || item)"
                        title="Delete User"
                    ></v-btn>
                </template>

                

<!-- 
                <template v-if="items.length < 8" v-slot:bottom>
                    <v-row>

                    </v-row>    
                </template> -->
            </VDataTable>

        <v-container class=" d-flex justify-end">

               
        </v-container>
        

    </v-card>
</template>
<style>

.highlight-row:hover {
  background-color: #3b6e3d;
  cursor: pointer;
}

</style>
<script>
import { ref, onMounted, computed, reactive, watch } from "vue";
import { useUserStore } from "@/store/users";
import { useAuthStore } from "@/store/auth";
import { VDataTable } from "vuetify/components";
import { useRouter } from 'vue-router'
import ConfirmationDialog from "../ConfirmationDialog.vue";
import { api } from '@/composables/api';



export default {
    props:{ },
    emits: ['create', 'edit', 'delete'],
    setup(props, { emit }) {
        const store = useUserStore();
        const authStore = useAuthStore();

        const expanded = ref([]);
        const schools = ref([]);

        const router= useRouter();

        // Define available roles
        const roles = [
            { name: 'admin' },
            { name: 'maintainer' },
            { name: 'user' },
            { name: 'guest' },
            { name: 'read-only' }
        ];

        const activeUsers = computed(() => {
            return store.users.filter((user) => user.role && user.role !== 'pending' && user.role !== 'root');
        });

        const pendingUsers = computed(() => {
            return store.users.filter((user) => user.role === 'pending');
        });

        const items = computed(() => { return store.users });

        const deleteConfirmation = ref(null);
        const pendingUserDelete = reactive({
            _id: 0,
            username: null
        })

        onMounted(() => {
            store.fetchUsers();
            loadSchools();
        });

 
        const headers = ref([
            { align: 'left' , title: 'Name', key: 'username', sortable: false },
            { title: 'Email', key: 'email', sortable: false },
            { title: 'Organization', key: 'organization', sortable: false },
            { title: 'Role', key: 'role', sortable: false, width:"10%"},
            { title: 'Actions', key: 'actions', sortable: false },
        ]);

        function getUserDisplayName(user) {
            if (!user) return 'Unknown User';
            if (user.username) {
                return user.username;
            }
            const firstName = user.first_name || user.first || '';
            const lastName = user.last_name || user.last || '';
            const fullName = `${firstName} ${lastName}`.trim();
            return fullName || user.email || 'Unknown User';
        }

        function getSchoolName(schoolId) {
            if (!schoolId) return '-';
            const school = schools.value.find(s => s.id === schoolId);
            return school ? school.name : schoolId;
        }

        async function loadSchools() {
            try {
                const response = await api.get('/schools');
                schools.value = response.data || response || [];
            } catch (error) {
                console.error('Error loading schools:', error);
                schools.value = [];
            }
        }


        function onRowClick(e, { item }){

            //router.push({ name: 'platforms', params: { platformId: item.value } });
           //router.push('/platforms/' + item.value);

        }



        function verifyDelete(user) {
            console.log('verifyDelete called with:', user);
            if (!user) {
                console.error('verifyDelete: user is null or undefined!');
                return;
            }
            emit('delete', user);
        }

        function deleteUser ()
        {
            // Deprecated - now handled by parent component
        }

        async function updateUserRole(user, role) {
            await store.updateUser(user, {role: role} );
            await store.fetchUsers();
        }

        async function add()
        {
            console.log('add');
        }

        function handleEdit(item) {
            console.log('handleEdit called with item:', item);
            console.log('item.raw:', item.raw);
            const user = item.raw || item;
            console.log('Emitting edit with user:', user);
            emit('edit', user);
        }


        return {
            items,
            activeUsers,
            pendingUsers,
            updateUserRole,
            deleteUser,
            headers,
            expanded,
            onRowClick,
            verifyDelete,
            deleteConfirmation,
            pendingUserDelete,
            authUser: authStore.authUser,
            roles,
            add,
            getUserDisplayName,
            getSchoolName,
            handleEdit

        }
    },
    components: {
    VDataTable,
    ConfirmationDialog
}
}


</script>
